module.exports = __webpack_public_path__ + "img/BETA_alpha.2d638472.png";